import { buildURL } from '../util';

export const moduleColor = ({ on }) => {
	on('@init', () => {
		const state = {
			width: 250,
			dark: '000',
			light: 'fff',
			value: 'Hello',
		};

		return {
			...state,
			stateBox: 'url',
			url: buildURL('svg', state),
		};
	});

	on('toggle/state', (_, stateBox) => {
		return { stateBox };
	});

	on('change/image', (state, [key, data]) => {
		return {
			[key]: data,
			url: buildURL('svg', { ...state, [key]: data }),
		};
	});
};